import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { PricingAudit } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/pricing-audit")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <PricingAudit />
    </RouteGuard>
  ),
});
